module.exports = __webpack_public_path__ + "static/media/tagLeft.8c81640c.svg";